export default "./dist/stdassets/cursors/digitizeLineString.cur";